import api from './api';

export type ServiceType = {
  _id: string;
  name: string;
  description?: string;
  icon?: string;
};

export type ServiceSubType = {
  _id: string;
  name: string;
  description?: string;
  serviceType: string; // ID of the parent ServiceType
};

export type GalleryImage = {
  _id: string;
  url: string;
  filename: string;
  serviceType: ServiceType; // Populated object
  serviceSubType?: ServiceSubType; // Populated object
  uploadedBy: { _id: string; name: string; email: string }; // Populated user
  description?: string;
  createdAt: string;
};

export type GalleryImagesResponse = {
  images: GalleryImage[];
  totalDocs: number;
  limit: number;
  page: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
};

export const galleryAPI = {
  getServiceTypes: async (): Promise<ServiceType[]> => {
    const response = await api.get('/gallery/types');
    return response.data.data;
  },

  getServiceSubTypes: async (serviceTypeId: string): Promise<ServiceSubType[]> => {
    const response = await api.get(`/gallery/subtypes?serviceTypeId=${serviceTypeId}`);
    return response.data.data;
  },

  uploadImages: async (formData: FormData): Promise<GalleryImage[]> => {
    const response = await api.post('/gallery/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data.data;
  },

  getGalleryImages: async (params?: { serviceType?: string; serviceSubType?: string; q?: string; page?: number; limit?: number }): Promise<GalleryImagesResponse> => {
    const response = await api.get('/gallery/images', { params });
    return response.data.data;
  },

  deleteGalleryImage: async (id: string): Promise<void> => {
    await api.delete(`/gallery/images/${id}`);
  },
};
